// extracted by mini-css-extract-plugin
export default {"page":"styles_page__qlikC","home":"styles_home__GNrXI","xiahua":"styles_xiahua__AsOs8"};